var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHeartFill = function SvgHeartFill(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 9.398c0 1.26-.52 2.48-1.457 3.405L12 19.5l-6.553-6.697C4.52 11.878 4 10.658 4 9.398 4 6.604 6.12 4.5 8.943 4.5c1.029 0 2.099.437 3.057 1.25.958-.813 2.028-1.25 3.057-1.25C17.87 4.5 20 6.604 20 9.398"
  })));
};
export { SvgHeartFill as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='currentColor' d='M20 9.398c0 1.26-.52 2.48-1.457 3.405L12 19.5l-6.553-6.697C4.52 11.878 4 10.658 4 9.398 4 6.604 6.12 4.5 8.943 4.5c1.029 0 2.099.437 3.057 1.25.958-.813 2.028-1.25 3.057-1.25C17.87 4.5 20 6.604 20 9.398'/%3e%3c/svg%3e";